import type { PurchaseRequest, PurchaseRequestStatus } from './usePurchaseRequests';

/* ── Helpers puros da visão ProcurementRequests (testáveis, sem framework) ── */

export const REQUEST_STATUS_META: Record<
  PurchaseRequestStatus,
  { variant: 'neutral' | 'info' | 'success' | 'error'; label: string }
> = {
  DRAFT: { variant: 'neutral', label: 'Rascunho' },
  PENDING_APPROVAL: { variant: 'info', label: 'Aguard. aprovação' },
  APPROVED: { variant: 'success', label: 'Aprovada' },
  REJECTED: { variant: 'error', label: 'Reprovada' },
  CONVERTED: { variant: 'success', label: 'Convertida' },
  CANCELLED: { variant: 'error', label: 'Cancelada' },
};

export function requestStatusMeta(status: string): { variant: 'neutral' | 'info' | 'success' | 'error'; label: string } {
  return (
    (REQUEST_STATUS_META as Record<string, { variant: 'neutral' | 'info' | 'success' | 'error'; label: string }>)[status] ?? {
      variant: 'neutral',
      label: status,
    }
  );
}

export function requestEstimatedTotal(request: PurchaseRequest): number {
  return request.items.reduce((sum, item) => sum + (item.estimatedTotalCost || 0), 0);
}

export interface RequestsSummary {
  count: number;
  pendingApproval: number;
  urgent: number;
  estimatedTotal: number;
}

/** Agregação client-side sobre os itens carregados (rotular "página atual" na UI). */
export function summarizeRequests(items: PurchaseRequest[]): RequestsSummary {
  return items.reduce<RequestsSummary>(
    (acc, r) => ({
      count: acc.count + 1,
      pendingApproval: acc.pendingApproval + (r.status === 'PENDING_APPROVAL' ? 1 : 0),
      urgent: acc.urgent + (r.urgent ? 1 : 0),
      estimatedTotal: acc.estimatedTotal + requestEstimatedTotal(r),
    }),
    { count: 0, pendingApproval: 0, urgent: 0, estimatedTotal: 0 },
  );
}

/** Busca client-side sobre número, justificativa e solicitante. */
export function filterRequests(items: PurchaseRequest[], search: string): PurchaseRequest[] {
  const term = search.trim().toLowerCase();
  if (!term) return items;
  return items.filter((r) =>
    [r.requestNumber, r.justification, r.requestedBy].some((field) =>
      (field ?? '').toLowerCase().includes(term),
    ),
  );
}
